import React from 'react';
import { ErrorBoundary } from '@datadog/browser-rum-react';

interface ErrorFallbackProps {
  resetError: () => void;
  error: Error;
}

const ErrorFallback: React.FC<ErrorFallbackProps> = ({ resetError, error }) => {
  // Log detailed error information to console for debugging
  console.error('🚨 Error Boundary Caught Error:', {
    message: error.message,
    stack: error.stack,
    name: error.name,
    cause: error.cause,
    timestamp: new Date().toISOString(),
    userAgent: navigator.userAgent,
    url: window.location.href
  });

  return (
    <div style={{ 
      padding: '20px', 
      border: '1px solid #dc3545', 
      borderRadius: '4px', 
      backgroundColor: '#f8d7da', 
      color: '#721c24',
      margin: '20px'
    }}>
      <h3>Something went wrong!</h3>
      <p><strong>Error:</strong> {String(error)}</p>
      <details style={{ marginTop: '10px' }}>
        <summary style={{ cursor: 'pointer', fontWeight: 'bold' }}>Error Details (Click to expand)</summary>
        <pre style={{ 
          marginTop: '10px', 
          padding: '10px', 
          backgroundColor: '#f8f9fa', 
          border: '1px solid #dee2e6',
          borderRadius: '4px',
          fontSize: '12px',
          overflow: 'auto',
          maxHeight: '200px'
        }}>
          {error.stack || 'No stack trace available'}
        </pre>
      </details>
      <button 
        onClick={resetError}
        style={{
          padding: '8px 16px',
          backgroundColor: '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          marginTop: '10px'
        }}
      >
        Try again
      </button>
    </div>
  );
};

interface DatadogErrorBoundaryProps {
  children: React.ReactNode;
  fallback?: React.ComponentType<ErrorFallbackProps>;
}

const DatadogErrorBoundary: React.FC<DatadogErrorBoundaryProps> = ({ 
  children, 
  fallback = ErrorFallback 
}) => {
  return (
    <ErrorBoundary fallback={fallback}>
      {children}
    </ErrorBoundary>
  );
};

export default DatadogErrorBoundary; 